import { ActiveUser, FileCheckpointInfo } from '../../../shared/models';
import { ByteAuditLogModificationEvent } from '../../services/active-users.service';

export interface ActiveUsersModel {
  users: ActiveUser[];
  currentCheckpoint: FileCheckpointInfo | null;
  isFileOutdated: boolean;
  isEnabled: boolean;
  currentFileDataId: number | null;
  lastModificationEvent: ByteAuditLogModificationEvent | null;
}

export function createInitialActiveUsersState(): ActiveUsersModel {
  return {
    users: [],
    currentCheckpoint: null,
    isFileOutdated: false,
    isEnabled: false,
    currentFileDataId: null,
    lastModificationEvent: null,
  };
}
